module.exports = __webpack_public_path__ + "src/assets/images/excel_icon.46d633211714d99d51584d96e5e73774.png";